import { Injectable } from '@angular/core';
import { AbstractNavigationDataService, NavigationData, OverlayService } from '@finra/rampdi-forms-common';
import { environment } from '../../environments/environment';
import { ActivatedRouteSnapshot } from '@angular/router';

export const FORM_TYPES = {
  INITIAL: 'INITIAL',
};

const navView: NavigationData[] = [
  {
    type: 'header',
    id: 'dataEntry',
    text: environment.formName,
    skip: true,
    children: [
      {
        id: 'identifyingInformation',
        text: 'Identifying Information',
        modelPath: [],
        pointerList: [/^#\/identifyingInformation/],
      },
      {
        id: 'residentRegisteredAgent',
        text: 'Resident/Registered Agent',
        modelPath: [],
        pointerList: [/^#\/residentRegisteredAgent/],
      },
      {
        id: 'webAddresses',
        text: 'Web Addresses',
        modelPath: [],
        pointerList: [/^#\/webAddresses/],
      },
      {
        id: 'approvalsAndDesignations',
        text: 'Approvals and Designations',
        modelPath: [],
        pointerList: [/^#\/approvalsAndDesignations/],
      },
      {
        id: 'legalStatusDataCollection',
        text: 'Legal Status - Data Collection',
        modelPath: [],
        pointerList: [/^#\/legalStatusDataCollection/],
      },
      {
        id: 'affiliatesSubsidiaries',
        text: 'Affiliates/Subsidiaries',
        modelPath: [],
        pointerList: [/^#\/affiliatesSubsidiaries/],
      },
      {
        id: 'financialInstitutions',
        text: 'Financial Institutions',
        modelPath: [],
        pointerList: [/^#\/financialInstitutions/],
      },
    ],
  },
];

const formView: NavigationData[] = [
  {
    id: 'formView',
    type: 'header',
    text: 'Form View',
    skip: true,
    children: [
      {
        id: 'formViewIdentifyingInformation',
        text: 'Identifying Information',
        modelPath: [],
        pointerList: [/^#\/identifyingInformation/],
      },
      {
        id: 'formViewResidentRegisteredAgent',
        text: 'Resident/Registered Agent',
        modelPath: [],
        pointerList: [/^#\/residentRegisteredAgent/],
      },
      {
        id: 'formViewWebAddresses',
        text: 'Web Addresses',
        modelPath: [],
        pointerList: [/^#\/webAddresses/],
      },
      {
        id: 'formViewApprovalsAndDesignations',
        text: 'Approvals and Designations',
        modelPath: [],
        pointerList: [/^#\/approvalsAndDesignations/],
      },
      {
        id: 'formViewLegalStatusDataCollection',
        text: 'Legal Status - Data Collection',
        modelPath: [],
        pointerList: [/^#\/legalStatusDataCollection/],
      },
      {
        id: 'formViewAffiliatesSubsidiaries',
        text: 'Affiliates/Subsidiaries',
        modelPath: [],
        pointerList: [/^#\/affiliatesSubsidiaries/],
      },
      {
        id: 'formViewFinancialInstitutions',
        text: 'Financial Institutions',
        modelPath: [],
        pointerList: [/^#\/financialInstitutions/],
      },
    ],
  },
];
@Injectable({
  providedIn: 'root',
})
export class NavigationDataService extends AbstractNavigationDataService {
  licensesList: any[] = [];

  constructor(public OS: OverlayService) {
    super({
      dataEntry: {
        [FORM_TYPES.INITIAL]: navView,
      },
      formView: {
        [FORM_TYPES.INITIAL]: formView,
      },
    });
  }

  // Override getNavData to handle version-specific navigation
  getNavData(key: string, sectionId?: string): any[] {
    return super.getNavData(key, sectionId);
  }

  // Override getNavItem to handle version-specific navigation
  getNavItem(key: string, navId: string): any {
    return super.getNavItem(key, navId);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const { instance } = route.parent.data.instanceData;
    const filingType = instance?.instanceMetadata?.attributes?.filingTypeCode;
    const navId = route.params.sectionId;
    return this.getNavData(`${route.params.viewType}.${filingType}`, navId);
  }

  closeSnackbar() {
    // Close any active snackbar directly instead of creating a new empty one
    if (this.OS.activeToastInstance) {
      this.OS.activeToastInstance.close();
    }
  }
}
